var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo07(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 790 1257.4",
    style: {
      enableBackground: "new 0 0 790 1257.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000133519717509691956440000009027288440042445952_);fill:#F7B28C;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 790,
    height: 1257.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124854738403579763640000012373114547416696981_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000124854738403579763640000012373114547416696981_)",
      fill: "#F7B28C"
    },
    d: "M790,199.3 c-53.2,74.9-100.6,155.2-142.2,241c-41.7,85.8-78.2,173.9-109.6,264.5c-31.4,90.6-57.4,182.7-77.9,276.3 c-20.6,93.6-36.2,185.7-47.1,276.3H139.5c9.7-77.3,24.1-158.5,43.5-243.7c19.3-85.2,45-171.8,77-260 c32-88.2,70.9-176.9,116.9-266.3c45.9-89.4,100.2-176.9,163.1-262.7H0V0h790V199.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo07);
export default __webpack_public_path__ + "static/media/no-07.de9f35a3b5c68660f8a252c6e0c43a2e.svg";
export { ForwardRef as ReactComponent };